import { PopupTheme } from './enums';

export const TRANSFER_POPUP_STORAGE_KEY = 'TPTheme';
export const EMAIL_CONFIRMATION_PARTNER_LOGIN_ID = '21';
export const AVAILABLE_THEMES = [PopupTheme.Default, PopupTheme.Carousel];
